<template>
  <div>
    <spacer :y="15"/>
    <div>
      <img :class="$style.logo" src="@/assets/images/logo_vertical.png" alt="logo">
    </div>
    <spacer :y="5"/>
    <h2 :class="$style.title">パスワード再発行</h2>

    <spacer :y="3"/>
    <p
      :class="$style.message"
      v-if="!flag.sended && !error.flag">ご登録のメールアドレスを入力・送信してください。</p>
    <p
      :class="$style.message"
      v-if="flag.sended
        && !flag.updated
        && !error.flag">送信いただいたメールアドレスのご登録は存在しませんでした。ご登録のメールアドレスをご確認ください。</p>
    <p
      :class="$style.message"
      v-if="flag.sended
        && flag.updated
        && !error.flag">ご登録のメールアドレスにメールを送信しました。<br>メールに記載されているURLからパスワードの再設定を行ってください。<br>届かない場合は、迷惑メールフォルダもご確認ください。<br>※ 受信制限をしている場合は、Welcome to talk ＜donotreply@welcometotalk.com＞を受信できるよう設定してください。<br>※ 再設定用URLの有効期限は24時間です。</p>
    <spacer :y="3"/>

    <form
      v-on:submit="submit"
      autocomplete="off">
      <div :class="$style.form">
        <div :class="$style.input">
          <input
            id="mail"
            type="email"
            name="mail"
            placeholder="メールアドレス"
            v-bind:disabled="flag.sended && flag.updated"
            v-model.trim="$v.mail.$model"
            v-bind:class="{ input_error: validationFlags.mail }"
            v-on:input="invalidsCheck('mail', $v.mail.$invalid)"
            >
          <p
            :class="$style.comment"
            v-if="$v.mail.$dirty
              && $v.mail.required.$invalid">メールアドレスを入力してください</p>
          <p
            :class="$style.comment"
            v-if="$v.mail.$dirty
              && $v.mail.email.$invalid">正しいメールアドレスの形式で入力してください</p>
        </div>
      </div>
      <spacer :y="3"/>
      <div v-if="!flag.updated" :class="$style.message">
        <p>
          登録アドレスにパスワード再設定メールを送信します。<br>
          届かない場合は、迷惑メールフォルダもご確認ください。<br>
          ※ 受信制限をしている場合は、Welcome to talk ＜donotreply@welcometotalk.com＞を受信できるよう設定してください。<br>
          ※ 再設定用URLの有効期限は24時間です。
        </p>
        <spacer :y="3"/>
      </div>
      <p v-else :class="[$style.message, $style.error]" v-html="error.message" />
      <div
        v-if="!flag.updated"
        :class="$style.wrap">
        <button
          type="submit"
          :class="$style.btn"
          v-bind:disabled="!submitFlag">送信</button>
      </div>
      <div v-else :class="$style.message">
        <p>※届かない場合はメールアドレスが間違っている可能性がありますので<br>メールアドレスが正しいかご確認のうえ、再度お試しください。</p>
        <spacer :y="3"/>
        <button
          :class="$style.btn"
          @click="goLogin">ログイン画面に戻る</button>
      </div>
    </form>
    <spacer :y="15"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'forgot-password',
  mixins: [cf],
  components: {
    Spacer,
  },
  data() {
    return {
      validationFlags: {
        mail: false,
      },
      invalids: {
        mail: true,
      },
      flag: {
        sended: false,
        updated: false,
      },
      errorMessages: [
        '所属校が無効となっているためログインおよびパスワードリセットはできません。<br>管理者さまへご確認ください。',
      ],
      error: {
        flag: false,
        message: '',
      },
    };
  },
  created() {
  },
  setup() {
    const mail = ref('');

    const rules = {
      // メールは必須・email形式
      mail: { required, email },
    };

    const $v = useVuelidate(rules, { mail });

    return { mail, $v };
  },
  computed: {
    ...mapState(['user', 'page']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.mail && !(this.flag.sended && this.flag.updated);
    },
  },
  methods: {
    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    /** サブミット */
    submit(e) {
      this.showLoading();
      e.preventDefault();
      const data = { mail: this.mail };

      this.axios({
        method: 'POST',
        url: '/v1/user/forgotPassword',
        data,
      })
        .then(() => {
          this.flag.updated = true;
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            // 所属校が無効の場合
            this.error.flag = true;
            this.error.message = this.errorMessages[error.response.data.messageIndex];
          } else {
            console.log(error);
          }
        })
        .finally(() => {
          this.flag.sended = true;
          this.hideLoading();
        });
    },

    goLogin() {
      this.$router.push('/login/');
    },

    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  display: flex;
  justify-content: center;
}
.logo {
  margin: 0 auto;
  width: 300px;
  max-width: 100%;
}
.title {
  text-align: center;
  color: var(--orange-main);
}
.form {
  text-align: center;
}
.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  input {
    width: 100%;
    padding: 13px;
    border-radius: 8px;
    border: none;
    background-color: var(--gray-sub);
    outline: none;
  }
}
.comment {
  font-size: 12px;
  color: var(--pink);
}
.message {
  font-size: 12px;
  text-align: center;
  &.error {
    color: red;
  }
}
.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #666;
  font-weight: bold;
  color: #fff;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
}
</style>
